import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useMe } from '../../api/me.ts';
import { AdminNav } from '../../shell/admin-nav.tsx';
import { guardSection } from '../../shell/guard.ts';

// Owner admin (spec §2): a menu of the owner pages, then the open page.
export const Route = createFileRoute('/_authed/admin')({
  beforeLoad: guardSection('/admin'),
  component: AdminLayout,
});

function AdminLayout(): React.JSX.Element {
  const me = useMe();
  return (
    <div className="page">
      <AdminNav me={me} />
      <Outlet />
    </div>
  );
}
